<app-spinner-overlay></app-spinner-overlay>

<form
  class="form-step1"
  [formGroup]="formInclusioneModuli"
  [alignItems]="'flex-start'"
  appFormContainer
  [larghezza]="12"
  [gap]="10"
  [rowGap]="5"
  style="align-items: center"
>
  <!-- MATERIALITÀ -->
  @if (!isUtenteGo) {
    @if (mostraModuli('MATERIALITA')) {
      <div appFormElement [larghezza]="4">
        <mat-form-field
          appearance="fill"
          *ngIf="idModulo || (settore && arrayAnalisiMaterialita && arrayAnalisiMaterialita.length)"
          style="width: 100%; align-self: flex-start"
        >
          <div class="spinner-container">
            <mat-spinner [diameter]="25" *ngIf="isLoadingSpinner"></mat-spinner>
          </div>
          <mat-label>{{ descrizioneMaterialita }}</mat-label>
          <mat-select
            formControlName="idMaterialita"
            placeholder="Analisi Materialità"
            (selectionChange)="onSelectionChangeMaterialita($event, 'Analisi di Materialità')"
          >
            <mat-option
              *ngFor="let mate of arrayAnalisiMaterialita || []"
              [compareWith]="compareGenericoById"
              [value]="mate"
              >{{ mate.nome }} {{ mate.anno }}</mat-option
            >
          </mat-select>
          <button
            [disabled]="hasValue('idMaterialita')"
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Cancella"
            tabindex="-1"
            matTooltip="Cancella"
            (click)="clearInput('idMaterialita', $event)"
          >
            <mat-icon>clear</mat-icon>
          </button>

          @if (guidaDescrizione && !isUtenteGo) {
            <mat-hint [ngStyle]="{ color: !idModulo ? 'var(--mat-color-accent)' : 'grey' }">
              <mat-icon>error</mat-icon><span>{{ guidaDescrizione }}</span></mat-hint
            >
          }
        </mat-form-field>

        <button
          [disabled]="this.idModulo"
          mat-stroked-button
          *ngIf="!idModulo && arrayAnalisiMaterialita && !arrayAnalisiMaterialita?.length"
          (click)="addMaterialita()"
          class="btn-add-nuovo"
        >
          + Aggiungi Analisi di Materialità
        </button>
      </div>
    }

    <!-- DOPPIA MATERIALITÀ -->
    @if (mostraModuli('DOPPIA_MATERIALITA')) {
      <div appFormElement [larghezza]="4">
        <mat-form-field
          appearance="fill"
          *ngIf="idModulo || (settore && arrayDoppiaMaterialita && arrayDoppiaMaterialita.length)"
          style="width: 100%"
        >
          <div class="spinner-container">
            <mat-spinner [diameter]="25" *ngIf="isLoadingSpinner"></mat-spinner>
          </div>
          <mat-label>{{ descrizioneDoppiaMaterialita }}</mat-label>
          <mat-select
            formControlName="idDoppiaMaterialita"
            placeholder="Doppia Materialità"
            (selectionChange)="onSelectionChangeMaterialita($event, 'Doppia Materialità')"
          >
            <mat-option
              *ngFor="let doppiaMat of arrayDoppiaMaterialita || []"
              [compareWith]="compareGenericoById"
              [value]="doppiaMat"
              >{{ doppiaMat.nome }} {{ doppiaMat.anno }}</mat-option
            >
          </mat-select>
          <button
            [disabled]="hasValue('idDoppiaMaterialita')"
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Cancella"
            tabindex="-1"
            matTooltip="Cancella"
            (click)="clearInput('idDoppiaMaterialita', $event)"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>

        <button
          [disabled]="this.idModulo"
          mat-stroked-button
          *ngIf="!idModulo && arrayDoppiaMaterialita && !arrayDoppiaMaterialita?.length"
          (click)="addDoppiaMaterialita()"
          class="btn-add-nuovo"
        >
          + Aggiungi Doppia Materialità
        </button>
      </div>
    }
    <!-- SINTESI -->
    @if (mostraModuli('SINTESI')) {
      <div appFormElement [larghezza]="4">
        <mat-form-field
          appearance="fill"
          *ngIf="
            idModulo || (settore && arraySintesiSostenibilita && arraySintesiSostenibilita?.length)
          "
          style="width: 100%"
        >
          <div class="spinner-container">
            <mat-spinner [diameter]="25" *ngIf="isLoadingSpinner"></mat-spinner>
          </div>
          <mat-label>{{ descrizioneSintesi }}</mat-label>
          <mat-select
            formControlName="idSintesiSostenibilita"
            placeholder="Sintesi di Sostenibilità"
          >
            <mat-option
              *ngFor="let sintesi of arraySintesiSostenibilita || []"
              [compareWith]="compareGenericoById"
              [value]="sintesi"
              >{{ sintesi.nome }} {{ sintesi.anno }}
            </mat-option>
          </mat-select>
          <button
            [disabled]="hasValue('idSintesiSostenibilita')"
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Cancella"
            tabindex="-1"
            matTooltip="Cancella"
            (click)="clearInput('idSintesiSostenibilita', $event)"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>

        <button
          [disabled]="this.idModulo"
          mat-stroked-button
          *ngIf="!idModulo && arraySintesiSostenibilita && !arraySintesiSostenibilita?.length"
          (click)="addSintesi()"
          class="btn-add-nuovo"
        >
          + Aggiungi Sintesi di Sostenibilità
        </button>
      </div>
    }
    <!-- BILANCIO -->
    @if (mostraModuli('BILANCIO')) {
      <div appFormElement [larghezza]="4">
        <mat-form-field
          appearance="fill"
          *ngIf="
            idModulo ||
            (settore && arrayBilancioSostenibilita && arrayBilancioSostenibilita?.length)
          "
          style="width: 100%"
        >
          <div class="spinner-container">
            <mat-spinner [diameter]="25" *ngIf="isLoadingSpinner"></mat-spinner>
          </div>
          <mat-label>{{ descrizioneBilancio }}</mat-label>
          <mat-select
            formControlName="idBilancioSostenibilita"
            placeholder="Report di Sostenibilità"
          >
            <mat-option
              *ngFor="let bilancio of arrayBilancioSostenibilita || []"
              [compareWith]="compareGenericoById"
              [value]="bilancio"
              >{{ bilancio.nome }} {{ bilancio.anno }}</mat-option
            >
          </mat-select>
          <button
            [disabled]="hasValue('idBilancioSostenibilita')"
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Cancella"
            tabindex="-1"
            matTooltip="Cancella"
            (click)="clearInput('idBilancioSostenibilita', $event)"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>

        <button
          [disabled]="idModulo"
          mat-stroked-button
          *ngIf="!idModulo && arrayBilancioSostenibilita && !arrayBilancioSostenibilita?.length"
          (click)="addBilancio()"
          class="btn-add-nuovo"
        >
          + Aggiungi Report di Sostenibilità
        </button>
      </div>
    }
    <!-- POLICY -->
    @if (mostraModuli('POLICY')) {
      <div appFormElement [larghezza]="4">
        <mat-form-field
          appearance="fill"
          *ngIf="
            idModulo || (settore && arrayPolicySostenibilita && arrayPolicySostenibilita?.length)
          "
          style="width: 100%"
        >
          <div class="spinner-container">
            <mat-spinner [diameter]="25" *ngIf="isLoadingSpinner"></mat-spinner>
          </div>
          <mat-label>{{ descrizionePolicy }}</mat-label>
          <mat-select formControlName="idPolicySostenibilita" placeholder="Policy di Sostenibilità">
            <mat-option
              *ngFor="let policy of arrayPolicySostenibilita || []"
              [compareWith]="compareGenericoById"
              [value]="policy"
              >{{ policy.nome }} {{ policy.anno }}</mat-option
            >
          </mat-select>
          <button
            [disabled]="hasValue('idPolicySostenibilita')"
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Cancella"
            tabindex="-1"
            matTooltip="Cancella"
            (click)="clearInput('idPolicySostenibilita', $event)"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>

        <button
          [disabled]="this.idModulo"
          mat-stroked-button
          *ngIf="!idModulo && arrayPolicySostenibilita && !arrayPolicySostenibilita?.length"
          (click)="addPolicy()"
          class="btn-add-nuovo"
        >
          + Aggiungi Policy di Sostenibilità
        </button>
      </div>
    }
    @if (mostraModuli('PIANO')) {
      <!-- PIANO -->
      <div appFormElement [larghezza]="4">
        <mat-form-field
          appearance="fill"
          *ngIf="
            idModulo || (settore && arrayPianoSostenibilita && arrayPianoSostenibilita?.length)
          "
          style="width: 100%"
        >
          <div class="spinner-container">
            <mat-spinner [diameter]="25" *ngIf="isLoadingSpinner"></mat-spinner>
          </div>

          <mat-label>{{ descrizionePiano }}</mat-label>
          <mat-select formControlName="idPianoSostenibilita" placeholder="Piano di Sostenibilità">
            <mat-option
              *ngFor="let piano of arrayPianoSostenibilita || []"
              [compareWith]="compareGenericoById"
              [value]="piano"
              >{{ piano.nome }} {{ piano.anno }}</mat-option
            >
          </mat-select>
          <button
            [disabled]="hasValue('idPianoSostenibilita')"
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Cancella"
            tabindex="-1"
            matTooltip="Cancella"
            (click)="clearInput('idPianoSostenibilita', $event)"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>

        <button
          [disabled]="this.idModulo"
          mat-stroked-button
          *ngIf="!idModulo && arrayPianoSostenibilita && !arrayPianoSostenibilita?.length"
          (click)="addPiano()"
          class="btn-add-nuovo"
        >
          + Aggiungi Piano di Sostenibilità
        </button>
      </div>
    }
  }
  <!-- MOSTRA SOLO SE UTENTE NON GO -->

  <ng-container *ngIf="isUtenteGo">
    <!-- MOSTRA SOLO SE UTENTE GO  -->
    <div appFormElement [larghezza]="12">
      <app-separatore-label [styleSeparatore]="'small'"></app-separatore-label>
    </div>

    <div appFormElement [larghezza]="12" [riempi]="true">
      <div class="titolo-sezione-dialog">Non partire da zero</div>

      <div class="descrizione-sezione-dialog">
        Lega il tuo report all'Assessment di Sostenibilità effettuato in Sostenibile.go
      </div>
    </div>
  </ng-container>
  <!-- MOSTRA SOLO SE UTENTE GO  -->

  <div appFormElement [larghezza]="isUtenteGo ? 6 : 4">
    <mat-form-field
      appearance="fill"
      *ngIf="
        (idModulo || settore || isUtenteGo) &&
        arrayAnalisiAutovalutazione &&
        arrayAnalisiAutovalutazione?.length
      "
      style="width: 100%"
    >
      <div class="spinner-container">
        <mat-spinner [diameter]="25" *ngIf="isLoadingSpinner"></mat-spinner>
      </div>

      <mat-label>{{ descrizioneAssessment }}</mat-label>
      <mat-select
        formControlName="idAutovalutazioneCompilata"
        placeholder="Assessment di Sostenibilità"
      >
        <mat-option
          *ngFor="let auto of arrayAnalisiAutovalutazione"
          [compareWith]="compareAnalisiAutovalutazione"
          [value]="auto"
          >{{ auto.nome }} {{ auto.anno }}</mat-option
        >
      </mat-select>
      <button
        [disabled]="hasValue('idAutovalutazioneCompilata')"
        matSuffix
        mat-icon-button
        type="button"
        aria-label="Cancella"
        tabindex="-1"
        matTooltip="Cancella"
        (click)="clearInput('idAutovalutazioneCompilata', $event)"
      >
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>
  </div>
</form>
